"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const stack_navigator_1 = require("@rahtab/stack-navigator");
const ui_1 = require("@rahtab/ui");
const InstagramIcon_1 = __importDefault(require("@rahtab/ui/dist/icons/InstagramIcon"));
const PhoneIcon_1 = __importDefault(require("@rahtab/ui/dist/icons/PhoneIcon"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const image = require('../../assets/images/support-instagram.png');
const SupportScreen = ({ version }) => {
    const [imageWidth, setImageWidth] = react_1.useState(316);
    const callSupport = () => {
        let phoneNumber = '03134072';
        let phoneUrl;
        if (react_native_1.Platform.OS === 'android') {
            phoneUrl = `tel:${phoneNumber}`;
        }
        else {
            phoneUrl = `telprompt:${phoneNumber}`;
        }
        react_native_1.Linking.openURL(phoneUrl);
    };
    return (react_1.default.createElement(stack_navigator_1.Screen, { title: "\u0627\u0631\u062A\u0628\u0627\u0637 \u0628\u0627 \u0633\u0627\u0645\u0627\u0646\u0647", renderControls: () => {
            return (react_1.default.createElement(ui_1.Card, null,
                react_1.default.createElement(ui_1.CardContainer, null,
                    react_1.default.createElement(ui_1.Text, null, "\u0628\u0631\u0627\u06CC \u0637\u0631\u062D \u0633\u0648\u0627\u0644\u0627\u062A \u062E\u0648\u062F \u0628\u0627 \u0645\u0631\u06A9\u0632 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC \u062F\u0631 \u062A\u0645\u0627\u0633 \u0628\u0627\u0634\u06CC\u062F."),
                    react_1.default.createElement(ui_1.Button, { style: styles.callButton, color: "primary", variant: "outlined", onPress: callSupport },
                        react_1.default.createElement(ui_1.Text, { color: "primary", margin: "none" }, "\u062A\u0645\u0627\u0633 \u0628\u0627 \u0645\u0631\u06A9\u0632 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC \u0633\u0627\u0645\u0627\u0646\u0647 \u0631\u0647\u062A\u0627\u0628"),
                        react_1.default.createElement(PhoneIcon_1.default, null)))));
        }, renderMain: () => {
            return (react_1.default.createElement(react_native_1.ScrollView, { style: styles.container, contentContainerStyle: styles.contentContainer },
                react_1.default.createElement(ui_1.Card, { style: styles.card },
                    react_1.default.createElement(ui_1.CardContainer, null,
                        react_1.default.createElement(ui_1.Text, null, "\u0628\u0631\u0627\u06CC \u0627\u0637\u0644\u0627\u0639 \u0627\u0632 \u0622\u062E\u0631\u06CC\u0646 \u0627\u062E\u0628\u0627\u0631 \u0627\u06CC\u0646\u0633\u062A\u0627\u06AF\u0631\u0627\u0645 \u0631\u0647\u062A\u0627\u0628 \u0631\u0627 \u062F\u0646\u0628\u0627\u0644 \u06A9\u0646\u06CC\u062F."),
                        react_1.default.createElement(react_native_1.Image, { onLayout: (e) => {
                                setImageWidth(e.nativeEvent.layout.width);
                            }, source: image, style: react_native_1.StyleSheet.flatten([styles.image, { height: imageWidth }]), resizeMode: "cover" }),
                        react_1.default.createElement(ui_1.Button, { style: styles.callButton, color: "secondary", variant: "outlined", onPress: () => react_native_1.Linking.openURL('https://www.instagram.com/rahtab.network/') },
                            react_1.default.createElement(ui_1.Text, { color: "secondary", margin: "none" }, "\u0645\u0634\u0627\u0647\u062F\u0647 \u062D\u0633\u0627\u0628 \u0627\u06CC\u0646\u0633\u062A\u0627\u06AF\u0631\u0627\u0645 \u0631\u0647\u062A\u0627\u0628"),
                            react_1.default.createElement(InstagramIcon_1.default, null)))),
                react_1.default.createElement(ui_1.Text, { margin: "none", color: "white", style: styles.versionText },
                    "Ver ",
                    version)));
        } }));
};
exports.default = SupportScreen;
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
    },
    contentContainer: {
        flexGrow: 1,
        justifyContent: 'space-between',
    },
    callButton: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingHorizontal: ui_1.getSpacing(),
    },
    card: {
        margin: ui_1.getSpacing(),
    },
    image: {
        borderRadius: ui_1.getRadius(),
        marginBottom: ui_1.getSpacing(),
        width: '100%',
    },
    versionText: {
        width: '100%',
        backgroundColor: ui_1.Colors.midGray,
        textAlign: 'center',
        fontFamily: 'none',
    },
});
